<template>
  <v-card flat class="mx-auto tw-px-2 md:tw-px-4 tw-py-2 md:tw-py-4">
    <h3 class="c-blue-text c-title tw-text-base md:tw-text-xl tw-px-0 md:tw-px-10">
      <slot></slot>
      <hr class="tw-mt-4">
    </h3>
    <div class="tw-w-full tw-flex">
      <div class="tw-w-full tw-flex tw-justify-center tw-my-5 md:tw-my-8 tw-flex-wrap">
        <div class="tw-flex tw-px-2 md:tw-px-10 tw-items-center">
          <v-icon color="primary" size="80" alt="car">mdi-car-outline</v-icon>
          <h3 class="c-navy-text c-title tw-text-base md:tw-text-xl tw-px-2 md:tw-px-8"><span v-html="coverType"></span></h3>
        </div>
        <div class="tw-px-0 md:tw-px-10 tw-mt-5 md:tw-mt-0 tw-text-center lg:tw-text-left">
          <h4 class="c-blue-text tw-font-bold tw-text-sm">Total Annual Premium</h4>
          <h3 class="c-light-blue-text title-font tw-text-4xl md:tw-text-5xl">Kshs. {{ amount | formatNum }}</h3>
        </div>
      </div>
    </div>
    <div v-if="!progressHidden" class="tw-w-full tw-px-0 md:tw-px-8">
      <v-stepper alt-labels>
        <v-stepper-header>
          <v-stepper-step
              step="1"
              :complete="progress > 0"
          >
            Personal Details
          </v-stepper-step>

          <v-divider :color="progress > 0 ? 'secondary' : ''"></v-divider>

          <v-stepper-step
              step="2"
              :complete="progress > 35"
          >
            Vehicle Details
          </v-stepper-step>

          <v-divider :color="progress > 35 ? 'secondary' : ''"></v-divider>

          <v-stepper-step
              step="3"
              :complete="progress > 67"
          >
            Cover Summary
          </v-stepper-step>

          <v-divider :color="progress > 67 ? 'secondary' : ''"></v-divider>

          <v-stepper-step
              :complete="progress === 100"
              step="4">
            Make Payment
          </v-stepper-step>
        </v-stepper-header>
      </v-stepper>
    </div>
  </v-card>
</template>

<script>
import helpers from '@/utils/helpers';

export default {
  name: 'TopCard',
  props: {
    current: {
      type: String,
      default: '',
    },
    amount: Number,
    cover: Number,
    progressHidden: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    progress() {
      if (this.current === 'PersonalDetails') {
        return 0;
      }
      if (this.current === 'VehicleDetails') {
        return 33.33;
      }
      if (this.current === 'CoverSummary') {
        return 66.66;
      }
      if (this.current === 'BranchSelections') {
        return 80;
      }
      return 100;
    },
    coverType() {
      // eslint-disable-next-line no-nested-ternary
      return this.cover === 101 ? 'Comprehensive <br> Insurance Cover' : this.cover === 106 ? 'Third Party' : 'Bima Bamba';
    },
  },
  filters: {
    formatNum(num) {
      return helpers.numberToString(num);
    },
  },
};
</script>
<style lang="scss">
$stepper-header-elevation: 0;
.v-stepper {
  box-shadow: none!important;
}
</style>
